import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import React, { useState, useEffect } from "react";
import FormularioLogin from "./components/FormularioLogin";
import PrincipalGestion from "./components/PrincipalGestion";
import ConsultaFacturas from "./components/ConsultaFacturas";
import Footer from "./components/Footer";
import Header from "./components/Header";

function App() {
    const [mostrarLogin, setMostrarLogin] = useState(false);
    const [usuarioAutenticado, setUsuarioAutenticado] = useState(false);
    const [tipoUsuario, setTipoUsuario] = useState("");

    // Restaurar la sesión al cargar la aplicación
    useEffect(() => {
        const autenticado = JSON.parse(localStorage.getItem("usuarioAutenticado"));
        const tipo = localStorage.getItem("tipoUsuario");

        if (autenticado) {
            setUsuarioAutenticado(true);
            setTipoUsuario(tipo);
            setMostrarLogin(false); // Muestra la vista principal
        } else {
            setMostrarLogin(false); // Muestra el formulario de login
        }
    }, []);

    const manejarInicioSesion = (tipo) => {
        setMostrarLogin(false); // Oculta el formulario de login
        setUsuarioAutenticado(true); // Marca como usuario autenticado
        setTipoUsuario(tipo);

        // Guarda la sesión en localStorage
        localStorage.setItem("usuarioAutenticado", JSON.stringify(true));
        localStorage.setItem("tipoUsuario", tipo);
    };

    const volverConsulta = () => {
        setMostrarLogin(false); // Oculta el formulario de login
        setUsuarioAutenticado(false); // Marca como usuario no autenticado
    };

    const manejarCerrarSesion = () => {
        setUsuarioAutenticado(false); // Elimina la autenticación
        setMostrarLogin(true); // Muestra el formulario de login nuevamente

        // Limpia los datos de la sesión en localStorage
        localStorage.removeItem("usuarioAutenticado");
        localStorage.removeItem("tipoUsuario");
    };

    return (
        <div className="container-fluid container-sm bg-light vh-100 d-flex flex-column p-0 shadow">
            <div className="w-100" style={{ background: "#8b1f2c", width: '100%', height: '4px' }}></div>

            <Header setMostrarLogin={setMostrarLogin} setUsuarioAutenticado={setUsuarioAutenticado} 
                setTipoUsuario={setTipoUsuario} usuarioAutenticado={usuarioAutenticado} tipoUsuario={tipoUsuario} />
            
            {/* Contenido principal */}
            <main className="container d-flex flex-column align-items-center justify-content-center flex-grow-1">
                {mostrarLogin ? (
                    <FormularioLogin onInicioSesion={manejarInicioSesion} onVolverConsulta={volverConsulta} />
                ) : usuarioAutenticado && tipoUsuario === 'admin' ? (
                    <PrincipalGestion />
                ) : (
                    <ConsultaFacturas tipoUsuario={tipoUsuario} />
                )}
            </main>
            <Footer />
        </div>
    );
}

export default App;


